import { EnterprisePendingNotifier } from '@/features/enterprise-pending-notifier';
import { ServerNotificationsSync } from '@/features/server-notifications-sync';
import { NotificationsMenuTrigger } from '@/shared/ui/kit/notifications-menu-trigger';
import { RemainingChecks } from '@/shared/ui/kit/remaining-checks';
import { UserMenuTrigger } from '@/shared/ui/kit/user-menu-trigger';
import { HeaderActionsProps } from '../model/header-actions.props';


export function HeaderActionsPlatform ({ profile }: HeaderActionsProps) {
    if (!profile) return null;

    // По макету остаток пула команды и её план видят только Owner/Admin — Member видит личные данные.
    const membership = profile.team?.membership;
    const teamUsage  = membership && membership.role !== 'member' ? membership : null;

    return (
        <>
            <RemainingChecks
                checks_number={ teamUsage?.checks_remaining ?? profile.vetting_count ?? 0 }
                isTeam={ Boolean(teamUsage) }
            />

            <EnterprisePendingNotifier profile={ profile }/>

            <ServerNotificationsSync profile={ profile }/>

            <NotificationsMenuTrigger/>

            <UserMenuTrigger
                profile={ profile }
            />
        </>
    );
}
